export default "__VITE_PUBLIC_ASSET__b4d62516__"